module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_07-12206637ebbd98e0d5f80618d5ee21af.png";